import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from '@edx/frontend-platform/i18n';
import { getConfig } from '@edx/frontend-platform';

import messages from './messages';

const Head = () => {
  const { formatMessage } = useIntl();
  return (
    <Helmet>
      <title>
        {formatMessage(messages.PageTitle, { siteName: getConfig().SITE_NAME })}
      </title>
      <link rel="shortcut icon" href={getConfig().FAVICON_URL} type="image/x-icon" />
      <link
          rel="stylesheet"
          href="https://tudelft-public.s3.eu-central-1.amazonaws.com/profed-redwood/static/css/main-app-learning.css"
          type="text/css"
        />
    </Helmet>
  );
};

export default Head;
